<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/sLUPbq/tc-custom/FC-9781528967846.jpg?1685327317284?1725650125248" alt="This image is the cover for the book Zuat's Philosophy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Zuat's Philosophy
      </h1>
      <p class="bookDescription body article font2">
        <p>Zuat's Philosophy is a novel for general readers, especially young adults who are developing their world views. It endorses laissez-faire capitalism. The story may offend: * Academic philosophers who muddy the waters of philosophy * Lawyers who put law above ethics * Executives of big companies who use ruthless tactics against small competitors * Environmentalists who resent even mild criticism of their precious causes * Young ex-schoolies who self-immerse in alcohol * Religious believers who don't like: - Arguments put forward to challenge their faith - Exposure of yet another wearer of the cloth as a scumbag. A caution to Peruvians: You might not like the revival of memories of Peru of 1980s and 1990s, and the evil Shining Path. Every issue is potentially political. If hens went on strike, politicians (and novelists?) of left and right might debate fiercely the price of eggs. For the rest of you, please enjoy the development of an unlikely romance. It comes with each partner clarifying his/her philosophy and taking much mental and physical risk to achieve that. By the way, Zuat is short for Anzuátegui.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mike Cavendish
      </h2>
      
      <p class="authorDescription body article">Mike was born on 26 March 1950 at Strathfield, Sydney, Australia. His mother pretended marriage; his father had died nine months earlier. Mike is an only child. When Mike was eight, his mother died. His aunt adopted him and moved him to Wollongong, fifty miles south of Sydney. She was single, childless and a headmistress at an infant school. Back in Sydney, Mike worked for years in the Australian government Department of Defence, mainly as a civilian analyst of Navy Air Force battle exercises. He retired in 2005. He is single and lives with Tom, his cat.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?702b72d4